import React from 'react';
import './DataLibrary.scss';
import { getLibrary, idLibraryDelete, selectedIdLibrary } from '../../../../MainVIew/Library/libraryslice';


const DataLibrary = (props) => {
    //const [writers, setWriters] = useState();




const {dispatch} = props;
const onGetLibrary = () => {
    dispatch(getLibrary());
}

const onIdLibraryDelete = (e) => {

const item = {
    library_id: e.target.value,
}

    dispatch(selectedIdLibrary(e.target.value));
    dispatch(idLibraryDelete(item));
}

const onIdLibraryEdit = (e) => {

    const index= e.target.value;
    const selectItem = {
        id: props.libraryData.libraryContent[index].id, 
         writers: props.libraryData.libraryContent[index].writers,
         titles: props.libraryData.libraryContent[index].titles,
         category: props.libraryData.libraryContent[index].category,
         year: props.libraryData.libraryContent[index].year,
         content: props.libraryData.libraryContent[index].content,
         
         
    }
    props.onChangeItem(selectItem);
   
    //ADD SELECTED ITEM INTO REDUX- SWTCH OFF BECOUSE OF PUTTING STATE TO PARANT-SEE ONCHANGEITEM
   // dispatch(selectedLibraryContent(selectItem));


   // console.log(selectItem );

}

  const  renderTable = () => {
        let  data =  props.libraryData.libraryContent;


        return (
            data.map((item, index) => {
                //console.log(index);
                return(
                    <tr key={item.id}>
                        <td >{item.writers}</td>
                        <td >{item.titles}</td>
                        <td ><button className='smallbtnContent' ></button></td>
                        <td>{item.category}</td>
                        <td>{item.year}</td>
                        <td><button className='btnFavorites'></button>{item.score}</td>
                        <td className='btnCell'><button value={index} className='smallbtnEdit' onClick={onIdLibraryEdit}></button></td>
                        <td className='btnCell'><button value={item.id} className='smallbtnDelete' onClick={onIdLibraryDelete}></button></td>
                    </tr>
                    )
                })
            )    
       }


       return (
        <div className='DataLibrary'>
            <button className='updateButton' onClick={onGetLibrary}></button>
            <div className='sorting'>
                <p>Сортировать</p>
                <p>по рейтингу</p>
                 <p>по году</p>
            </div>
            <div>
            <table>
                            <thead>
                                <tr>
                                    <th className='writers'>Автор</th>
                                    <th className='titles'>Наименование</th>
                                    <th className='btnCell'></th>
                                    <th className='category'>Категория</th>
                                    
                                    <th className='year'>Год</th>
                                    <th className='rank'>Рейтинг</th>
                                    <th className='btnCell'></th>
                                    <th className='btnCell'></th>
                                </tr>
                                
                            </thead>
                            <tbody>
                            
                                {renderTable()}
                            
                            </tbody>
                        </table>
            </div>
           
        </div>
       )
        

    
}
export default DataLibrary;